<nav class="navbar" [class.mobile-layout-route]="isMobileLayoutRoute">
  <div class="logo_item">
    <a class="ms-1" *ngIf="!isMobile && !isFbiOnboardingRoute && !isWaterIntelligenceRoute" (click)="expandNavBar()">
      <img src="../../../assets/images/menus/menu-hamburger-icon.svg" class="hamburger-class-img" alt="" />
    </a>
    <a class="ms-1" *ngIf="isMobile && !isExpand && !isFbiOnboardingRoute && !isWaterIntelligenceRoute" (click)="expandNavBar()">
      <img src="../../../assets/images/menus/Hamburger-Mobile.svg" alt=""/>
    </a>
    <a class="ms-1" *ngIf="isMobile && isExpand && !isFbiOnboardingRoute && !isWaterIntelligenceRoute" (click)="onCloseNavBar()" >
      <img src="../../../assets/images/menus/Close.svg" alt="" />
    </a>
    <div class="logo-title-group">
      <a class="logo_img img-fluid margin-left" (click)="clickBtn()">
        <img src="../../../../assets/images/Ecolab3D_Logo.svg" alt="ECOLAB"  />
      </a>
      <div class="header-divider" *ngIf="!isMobile">
        <nalco-divider [color]="dividerCss.color" [length]="dividerCss.minLength" [isHorizontal]= dividerCss.isHorizontal></nalco-divider>
      </div>
      <h5 class="heading-small page-title" [innerHTML]="pageTitle | translate"></h5>
    </div>
  </div>
  <div class="navbar-globalsearch">
    <nalco-global-search-dropdown></nalco-global-search-dropdown>
  </div>
  <!-- For Future Search Bar Css  -->
  <!-- <div class="search_bar">
        <input type="text" placeholder="Search" />
      </div> -->
  <div *ngIf="!isFbiOnboardingRoute && !isWaterIntelligenceRoute">
    <nalco-menu class="expandmenu"></nalco-menu>
  </div>
  <div class="navbar_content margin-right" *ngIf="!isFbiOnboardingRoute && !isMobile">

    <div class="notification-class" *ngIf="showNotification"><nalco-notification (loader)="handleLoading($event)"></nalco-notification></div>
    <div class="dots-waffle" *ngIf="isFnbIntelligenceUser">
      <img class="dots-waffle-img" src="../../../assets/images/fbi-icons/dots-waffle.svg">
    </div>
    <span class="span-round" (click)="showDropdownForLogout()">{{Initials}}</span>
    <div class="profile-details">
      <label class="profile-label">{{userInfo.FirstName}} {{userInfo.LastName}}</label>
      <!-- For Future Role Css  -->
      <!-- <p class="role-label">Role</p></div> -->
    </div>
    <div class="custom-dropdown">
      <a class="custom-dropdown-link" *ngIf="!isMobile" >
        <img class="custom-dropdown-img" src="../../../assets/images/menus/arrows/arrow-down.svg">
      </a>
      <div class="custom-dropdown-menu" *ngIf="showDropdownMenu">
        <nalco-user-profile-details [user]="userInfo"></nalco-user-profile-details>
      </div>
    </div>
    <div *ngIf="enableAIAgent && !isFbiRoute && !isWaterIntelligenceRoute && !isLegionellaDashboardRoute && isFsqsRoute && isFsqsUser">
      <nalco-ai-agent [calledFromFsqs]="true"></nalco-ai-agent>
    </div>
    <div *ngIf="isFbiRoute || isWaterIntelligenceLandingRoute" (click)="openEVA()">
        <img src="../../../../../assets/Icon-AI-Agent.svg" class="ai-agent-icon" />
    </div>
    <!-- <div *ngIf="!isFbiRoute && isWaterIntelligenceLandingRoute">
      <nalco-eva-agent class="wi-landing__chat"></nalco-eva-agent>
    </div> -->
  </div>
  <!-- Commenting for 20240620 release only -->
  <!-- <div class="threedot-logo" id="dropdownBasic1" ngbdropdown   [ngClass]="isMobile && !isHomePage ? ' ' : 'display-none'">
    <a class="ms-1">
      <img src="../../../assets/images/3dot-vertical.svg" (click)="showThreeDotOptionsMenu()"   class="threedot-class-img" />
    </a>
  </div>
  <div ngbDropdown  *ngIf="showThreeDotOptions" class="custome-threedot-menu">
    <div  id="dropdownConfig">
      <button  class="dropdown-item" translate>COMMON.PROFILE</button>
      <button  class="dropdown-item" translate>COMMON.NOTIFICATIONS</button>
    </div>
  </div> -->

  <div class="mobile-header-actions" *ngIf="isMobile && !isFbiOnboardingRoute">
    <img *ngIf="!showMobileMenu"
         src="../../../assets/images/3dot-vertical.svg"
         class="mobile-three-dot-img"
         alt="Menu"
         (click)="toggleMobileMenu()" />
    <img *ngIf="showMobileMenu"
         src="../../../assets/images/menus/Close.svg"
         class="mobile-close-menu-img"
         alt="Close"
         (click)="toggleMobileMenu()" />
  </div>
</nav>

<div class="mobile-expanded-menu" *ngIf="isMobile && showMobileMenu && !isFbiOnboardingRoute">
  <ng-container *ngIf="!showMobileNotifications">
    <div class="mobile-menu-row" (click)="openMobileNotifications()">
      <div class="mobile-menu-row-left">
        <span class="mobile-menu-icon-wrap">
          <img src="../../../assets/images/menus/neptune-notification-icon.svg" class="mobile-menu-bell-icon" alt="Notifications" />
        </span>
        <span>{{'COMMON.NOTIFICATIONS' | translate}}</span>
      </div>
      <img src="../../../assets/images/menus/arrows/arrow-caret-right.svg" class="mobile-menu-chevron" alt="" />
    </div>

    <div class="mobile-menu-row mobile-menu-user-row">
      <div class="mobile-menu-row-left">
        <span class="mobile-user-avatar">{{Initials}}</span>
        <div class="mobile-user-info">
          <span class="mobile-user-name">{{userInfo.FirstName}} {{userInfo.LastName}}</span>
          <span class="mobile-user-email">{{userInfo.EmailAddress}}</span>
        </div>
      </div>
    </div>

    <div class="mobile-menu-row" (click)="logout()">
      <span>{{'COMMON.LOGOUT' | translate}}</span>
      <img src="../../../assets/images/menus/neptune-logout-icon.svg" class="mobile-logout-icon" alt="Logout" />
    </div>
  </ng-container>

  <ng-container *ngIf="showMobileNotifications">
    <div class="mobile-notification-back" (click)="closeMobileNotifications()">
      <img src="../../../assets/images/menus/arrows/arrow-caret-right.svg" class="mobile-back-chevron" alt="" />
      <span>{{'COMMON.BACK' | translate}}</span>
    </div>

    <ng-container *ngIf="!mobileNotifications.length">
      <div class="mobile-no-notifications">
        {{'NOTIFICATIONS.NO_NOTIFICATIONS' | translate}}
      </div>
    </ng-container>

    <ng-container *ngIf="mobileNotifications.length">
      <ul class="mobile-notification-list">
        <li *ngFor="let n of (mobileNotifications | slice:0:(showMobileNotificationAccordion ? mobileNotifications.length : 5))"
            class="mobile-notification-item"
            (click)="onMobileNotificationClick(n)">
          <img src="../../../assets/images/warning_amber.svg" class="mobile-notification-warning-icon" alt="" />
          <div class="mobile-notification-text">
            <div class="mobile-notification-heading">{{getMobileNotificationDetails(n).title}}</div>
            <div class="mobile-notification-message">
              {{getMobileNotificationDetails(n).message}}
              <span *ngIf="n.NotificationCategoryTypeId == 'DuplicateUnmappedDatasources'" class="mobile-notification-message-bold">{{n.id}}</span>
            </div>
          </div>
        </li>
      </ul>
      <ng-container *ngIf="mobileNotifications.length > 5 && !showMobileNotificationAccordion">
        <button class="mobile-view-all-button" (click)="toggleMobileNotificationAccordion()">
          {{'COMMON.VIEW_ALL' | translate}} ({{mobileNotifications.length}})
        </button>
      </ng-container>
      <ng-container *ngIf="showMobileNotificationAccordion">
        <button class="mobile-view-all-button" (click)="toggleMobileNotificationAccordion()">
          {{'COMMON.VIEW_LESS' | translate}}
        </button>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
<!-- this is the temproray fix for the sub header for time being  -->


<nalco-sub-header  *ngIf="user?.authenticated && !(hideSubHeader && isSubHeaderHidden) && !isFbiOnboardingRoute" [isExpand] = "isNewUIEnabled? isExpand : false" [isHomePage] = "isHomePage"></nalco-sub-header>

